// Données et utilitaires pour l'application FinanceHub
// Configuration fiscale Québec

export const CONFIG = {
  tps_rate: 0.05,
  tvq_rate: 0.09975,
  tax_rate_pme: 0.122,
  departments: ["PRQC", "LMDS", "LOCATION"],
  department_names: {
    "PRQC": "Peinture Résidentielle",
    "LMDS": "Le Marché du Store",
    "LOCATION": "Location Équipements",
    "GLOBAL": "Global"
  }
};

export const MONTHS = [
  "", "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
];

export const QUARTERS = ["T1", "T2", "T3", "T4"];

export const formatCurrency = (value, showSign = false) => {
  if (value === null || value === undefined) return "-";
  const formatted = new Intl.NumberFormat('fr-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(value));
  
  if (showSign && value !== 0) {
    return value > 0 ? `+${formatted}` : `-${formatted}`;
  }
  return value < 0 ? `-${formatted}` : formatted;
};

export const formatPercent = (value, decimals = 1) => {
  if (value === null || value === undefined) return "-";
  return `${value.toFixed(decimals)}%`;
};

export const formatNumber = (value, decimals = 0) => {
  if (value === null || value === undefined) return "-";
  return new Intl.NumberFormat('fr-CA', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

// Couleurs pour les graphiques
export const CHART_COLORS = {
  revenus: "#064E3B",
  depenses: "#DC2626",
  profit: "#D97706",
  prqc: "#064E3B",
  lmds: "#0EA5E9",
  location: "#8B5CF6",
  global: "#374151"
};

// Indicateurs avec leurs cibles
export const TARGETS = {
  marge_brute: 45,
  marge_nette: 15,
  roi: 20,
  pct_heures_terrain: 75,
  taux_signature: 40,
  frais_fixes_pct: 15
};
